import React from 'react';
import { Result, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import AccountsPage from '../Pages/AccountsPage';
import useOnce from '../Utils/hook/useOnce';
import { useAppDispatch, useAppSelector } from '../Modules/Presentation/hooks';
import { fetchAccounts } from '../Modules/Account/Presentation/actions';
import { selectUser } from '../Modules/User/Presentation/selectors';
import { selectAccounts } from '../Modules/Account/Presentation/selectors';


const AccountsRoutes = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUser = useAppSelector(selectUser);
  const accoutList = useAppSelector(selectAccounts)

  if (currentUser?.grade === 'SELLER') {
    return (
      <Result
        status="403"
        title="접근 권한이 없습니다"
        subTitle="이 페이지는 셀러 계정으로 접근할 수 없습니다."
        extra={
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 6, padding: '0 32px' }}
            onClick={() => navigate('/')}
          >
            홈으로 이동
          </Button>
        }
      />
    );
  }

  useOnce(() => {
    if (accoutList.length === 0) {
      dispatch(fetchAccounts())
        .unwrap()
        .catch(() => message.error('계정 정보를 불러오는데 실패하였습니다.'));
    }
  });

  return <AccountsPage />;
};

export default AccountsRoutes;
